const config = {
  API_URL: 'https://pattrak.com',
  APP_NAME: 'PatTrak',
  VERSION: '9.45'
};
export default config;